import { useSearchParams } from 'react-router-dom';
import { useIsTabbarHidden } from '../../../hooks/useIsTabbarHidden';

export const usePaddingBottom = () => {
    const [query] = useSearchParams();
    const isFromSearchApp = query.get('morda_platform') === 'search_app';

    const shouldHideMobileTabbar = useIsTabbarHidden();
    const disableSafeAreaPadding = isFromSearchApp;

    const paddingValue = shouldHideMobileTabbar ? '0px' : '56px';

    return {
        xs: disableSafeAreaPadding
            ? paddingValue
            : `calc(${paddingValue} + var(--safe-area-inset-bottom))`,
        sm: 0,
    };
};
